export const isCardExpirationValidTest = (value: string) => {
  const currentYear = new Date().getFullYear()
  const maxYear = currentYear + 14
  const year = parseInt(value.split('/')[1], 10) + 2000

  if (year < currentYear || year > maxYear) return false

  // check expired month in current year
  if (year === currentYear) {
    const month = parseInt(value.split('/')[0], 10)
    const currentMonth = new Date().getMonth() + 1
    if (month < currentMonth) return false
  }

  return true
}
